var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMachineLinkSmall = function SvgMachineLinkSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.83 4c0-1.197.973-2.17 2.17-2.17h2.8V.5H4A3.5 3.5 0 0 0 .5 4C.5 5.932 2.068 7.5 4 7.5h2.8V6.17H4A2.17 2.17 0 0 1 1.83 4m2.87.7h5.6V3.3H4.7zM11 .5H8.2v1.33H11c1.197 0 2.17.973 2.17 2.17S12.197 6.17 11 6.17H8.2V7.5H11c1.932 0 3.5-1.568 3.5-3.5S12.932.5 11 .5"
  })));
};
export default SvgMachineLinkSmall;